import React from 'react'
import { motion, useReducedMotion } from 'framer-motion'
import {
    FaCode,
    FaDownload,
    FaEnvelope,
    FaFacebookF,
    FaGithub,
    FaInstagram,
    FaLinkedinIn,
    FaTwitter,
    FaUser,
} from 'react-icons/fa'
import {
    AvailabilityBadge,
    ButtonContainer,
    ExploreButton,
    ContactButton,
    HeroContainer,
    HeroCopy,
    HeroFrame,
    HeroInnerContainer,
    HeroKicker,
    HeroLeftContainer,
    HeroRightContainer,
    Img,
    InfoCard,
    ResumeButton,
    SocialBar,
    SocialLink,
    SubTitle,
    Title,
    TitleAccent,
} from './HeroStyle'
import { Bio } from '../../data/constants';
const HeroImg = `${process.env.PUBLIC_URL || '.'}/IMG_6449.jpg`;

const HeroSection = () => {
    const reduceMotion = useReducedMotion();
    const handleScrollToProjects = () => {
        document.querySelector('#projects')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const reveal = {
        hidden: { opacity: 0, y: 26 },
        visible: { opacity: 1, y: 0 }
    };

    const cardReveal = {
        hidden: { opacity: 0, y: 22, scale: 0.98 },
        visible: { opacity: 1, y: 0, scale: 1 }
    };

    return (
        <HeroContainer id="home">
            <HeroInnerContainer
                as={motion.div}
                initial="hidden"
                animate="visible"
                transition={{ staggerChildren: 0.08 }}
            >
                <HeroLeftContainer as={motion.div} variants={cardReveal} transition={{ duration: 0.58, ease: "easeOut" }}>
                    <HeroFrame>
                        <AvailabilityBadge>
                            <span />
                            Open to Work
                        </AvailabilityBadge>
                        <Img
                            as={motion.img}
                            src={HeroImg}
                            alt="Professional portrait of Kisho Jeyapragash"
                            loading="eager"
                            fetchpriority="high"
                            decoding="async"
                            width={1729}
                            height={2593}
                            whileHover={{ scale: 1.015 }}
                            transition={{ type: "spring", stiffness: 180, damping: 18 }}
                        />
                        <InfoCard>
                            <FaUser />
                            <strong>Available for full-stack, backend, and AI integration roles</strong>
                        </InfoCard>
                    </HeroFrame>
                </HeroLeftContainer>

                <HeroRightContainer as={motion.div} variants={cardReveal} transition={{ duration: 0.58, ease: "easeOut", delay: 0.04 }}>
                    <HeroCopy>
                        <HeroKicker as={motion.div} variants={reveal} transition={{ duration: 0.5, ease: "easeOut" }}>
                            <span />
                            {Bio.heroTitle}
                        </HeroKicker>
                        <Title as={motion.h1} variants={reveal} transition={{ duration: 0.55, ease: "easeOut" }}>
                            {Bio.name.split(' ')[0]} <TitleAccent>{Bio.name.split(' ').slice(1).join(' ')}</TitleAccent>
                        </Title>
                        <SubTitle as={motion.p} variants={reveal} transition={{ duration: 0.5, ease: "easeOut" }}>
                            {Bio.heroDescription}
                        </SubTitle>
                        <ButtonContainer as={motion.div} variants={reveal} transition={{ duration: 0.5, ease: "easeOut" }}>
                            <ResumeButton href={Bio.resume} download aria-label="Download Resume (PDF)" title="Download resume as PDF">
                                <FaDownload />
                                Download Resume
                            </ResumeButton>
                            <ExploreButton onClick={handleScrollToProjects} aria-label="View Projects">
                                <FaCode />
                                View Projects
                            </ExploreButton>
                            <ContactButton href="#contact"><FaEnvelope /> Contact Me</ContactButton>
                        </ButtonContainer>
                        <SocialBar as={motion.div} variants={reveal} transition={{ duration: 0.5, ease: "easeOut" }} aria-label="Social links">
                            <SocialLink href={Bio.github} target="_blank" aria-label="GitHub" rel="noopener noreferrer"><FaGithub /></SocialLink>
                            <SocialLink href={Bio.linkedin} target="_blank" aria-label="LinkedIn" rel="noopener noreferrer"><FaLinkedinIn /></SocialLink>
                            <SocialLink href={Bio.twitter} target="_blank" aria-label="Twitter" rel="noopener noreferrer"><FaTwitter /></SocialLink>
                            <SocialLink href={Bio.insta} target="_blank" aria-label="Instagram" rel="noopener noreferrer"><FaInstagram /></SocialLink>
                            <SocialLink href={Bio.facebook} target="_blank" aria-label="Facebook" rel="noopener noreferrer"><FaFacebookF /></SocialLink>
                        </SocialBar>
                    </HeroCopy>
                </HeroRightContainer>
            </HeroInnerContainer>

        </HeroContainer>
    )
}

export default HeroSection

